import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { VehicleDeviceConfig } from './types';
export const VehicleDeviceConfigProvider = memo(function VehicleDeviceConfigProvider(props) {
    const { children, car_view, radiosilence, has_vehicle_sensors, has_vehicle_controls, has_gsm_balance, firmware_version, is_support_service_mode, } = props;
    const vehicle_device_config = useMemo(() => ({
        car_view,
        has_vehicle_sensors,
        is_support_service_mode,
        has_vehicle_controls,
        radiosilence,
        has_gsm_balance,
        firmware_version,
    }), [
        car_view,
        has_vehicle_sensors,
        has_vehicle_controls,
        is_support_service_mode,
        radiosilence,
        has_gsm_balance,
        firmware_version,
    ]);
    return (_jsx(VehicleDeviceConfig.Provider, { value: vehicle_device_config, children: children }));
});
export const useVehicleDeviceConfig = () => useContext(VehicleDeviceConfig);
